interface Coordinates {
	lat: number;
	lng: number;
}

let infowindow: any;
let map: google.maps.Map | undefined;
const markers: Record<string, google.maps.Marker> = {};

const loadGooglemaps = (cb: (err: string | null, gmaps?: typeof google.maps) => void) => {
	const paramArray = [
		'key=AIzaSyCY2vZO2_wuLPaCaw6jcOPx5LDe4VmlGww',
		'callback=googleMapsLocationsCallback',
	];

	if (window.gmaps) {
		return cb(null, window.gmaps);
	}

	if (window.gmapsScript) {
		return cb(null, window.gmaps);
	}

	window.gmapsScript = document.createElement('script');
	window.gmapsScript.type = 'text/javascript';
	window.gmapsScript.async = true;
	window.gmapsScript.src = '//maps.google.com/maps/api/js?' + paramArray.join('&');

	window.googleMapsLocationsCallback = function () {
		window.gmaps = window.google?.maps;
		window.googleMapsLocationsCallback = null;
		if (window.gmaps) {
			cb(null, window.gmaps);
		} else {
			cb('No gmaps object!');
		}
	};

	document.body.appendChild(window.gmapsScript);
};

const updateLocationSearch = (): void => {
	const input = document.querySelector<HTMLInputElement>(
		'.block-locations-zip-code-search__form input'
	);
	if (!input) {
		return;
	}

	const searchZip = input.value.replace('<', '[').replace('>', ']');
	const results = document.querySelectorAll<HTMLElement>(
		'.location-results, .location-results-button, .location-results .location'
	);
	const list = document.querySelector<HTMLElement>('.locations-list');

	if (searchZip.length !== 5) {
		results.forEach((el) => (el.style.display = 'none'));
		if (list) list.style.display = '';
		return;
	}

	if (list) list.style.display = 'none';
	results.forEach((el) => (el.style.display = ''));

	const geokoder = new window.google.maps.Geocoder();
	let geocodeSearch: google.maps.GeocoderRequest | google.maps.GeocoderComponentRestrictions = {
		address: searchZip,
	};

	if (searchZip.length === 5 && !isNaN(Number(searchZip))) {
		geocodeSearch = {
			componentRestrictions: {
				country: 'US',
				postalCode: searchZip,
			},
		};
	}

	geokoder.geocode(geocodeSearch as google.maps.GeocoderRequest, (result, status) => {
		if (status !== 'OK' || !result || !result[0]) return;
		const searchingPoint: Coordinates = {
			lat: result[0].geometry.location.lat(),
			lng: result[0].geometry.location.lng(),
		};
		findNearestLocations(searchingPoint);
	});
};

const applicationMaps = (): void => {
	const fullMapEl = document.getElementById('full-map');
	if (fullMapEl) {
		map = new window.google.maps.Map(fullMapEl, {
			zoom: window.innerWidth > 1199 ? 5 : 4,
			center: { lat: 38.5, lng: -96.5696 },
			gestureHandling: 'none',
		});

		document.querySelectorAll<HTMLElement>('.location-results .location').forEach((el) => {
			const key = el.getAttribute('data-id');
			if (!key) return;

			const lat = Number(el.getAttribute('data-lat'));
			const lng = Number(el.getAttribute('data-lng'));

			const marker = new window.google.maps.Marker({
				position: { lat, lng },
				icon: '/wp-content/themes/sono-bello/assets/images/map-icon.svg?v2',
				map,
			});

			markers[key] = marker;

			marker.addListener('click', () => {
				createInfowindow(key);
			});
		});
	}

	const input = document.querySelector<HTMLInputElement>(
		'.block-locations-zip-code-search__form input'
	);
	const form = document.querySelector<HTMLFormElement>('.block-locations-zip-code-search__form');

	if (input) {
		input.addEventListener('keyup', updateLocationSearch);
	}
	if (form) {
		form.addEventListener('submit', (e) => {
			e.preventDefault();
			updateLocationSearch();
		});
	}

	updateLocationSearch();
};

const findNearestLocations = (point: Coordinates): void => {
	const list = document.querySelector<HTMLElement>('.locations-list');
	if (list) list.style.display = 'none';

	const locations = Array.from(
		document.querySelectorAll<HTMLElement>(
			'.location-results .location-results-container .location'
		)
	);

	const distances: { d: number; id: string | null }[] = [];

	locations.forEach((el) => {
		const lat = Number(el.getAttribute('data-lat'));
		const lng = Number(el.getAttribute('data-lng'));
		const dist = distance(point, { lat, lng });

		distances.push({ d: dist, id: el.id });
		el.setAttribute('data-distance', dist.toString());
		const span = el.querySelector('span');
		if (span) span.innerHTML = `(${Math.round(dist * 100) / 100} Miles)`;
		el.style.display = 'none';
	});

	locations
		.sort(
			(a, b) =>
				Number(a.getAttribute('data-distance')) - Number(b.getAttribute('data-distance'))
		)
		.forEach((el) => {
			el.parentNode?.appendChild(el);
		});

	for (let i = 0; i < 4; i++) {
		if (locations[i]) locations[i].style.display = '';
	}

	const results = document.querySelector<HTMLElement>('.location-results');
	if (results) results.style.display = '';
};

const distance = (coordsA: Coordinates, coordsB: Coordinates): number => {
	const radlat1 = (Math.PI * coordsA.lat) / 180;
	const radlat2 = (Math.PI * coordsB.lat) / 180;
	const theta = coordsA.lng - coordsB.lng;
	const radtheta = (Math.PI * theta) / 180;
	let dist =
		Math.sin(radlat1) * Math.sin(radlat2) +
		Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
	dist = Math.acos(dist);
	dist = (dist * 180) / Math.PI;
	dist = dist * 60 * 1.1515;
	return dist;
};

const createInfowindow = (locationId: string): void => {
	if (infowindow && typeof infowindow.close === 'function') {
		infowindow.close();
	}

	const el = document.querySelector<HTMLElement>(`.location[data-id="${locationId}"]`);
	if (!el) return;

	const location = {
		ID: el.getAttribute('data-id') || '',
		title: el.getAttribute('data-display-city') || '',
		permalink: el.getAttribute('data-permalink') || '',
		phone: el.getAttribute('data-phone') || '',
		address: `${el.getAttribute('data-address')}<br/>${el.getAttribute(
			'data-city'
		)}, ${el.getAttribute('data-state')} ${el.getAttribute('data-zip')}`,
	};

	const contentString = `
		<div class="info-window">
			<h3 class="t5"><a href="${location.permalink}">${location.title}</a></h3>
			<p class="body-small">${location.address}</p>
			<p class="body-small"><a href="tel:${location.phone}">
				<i class="fa fa-phone"></i>&nbsp;&nbsp;${location.phone}</a></p>
			<p class="body-small"><a href="${location.permalink}">Location Details</a></p>
		</div>`;

	infowindow = new window.InfoBubble({
		map,
		content: contentString,
		maxWidth: 500,
		maxHeight: 400,
		minWidth: 400,
		minHeight: 200,
		class: 'info-window',
		backgroundClassName: 'info-window-bg',
		closeSrc: '/wp-content/themes/sono-bello/assets/images/x-icon.svg',
		shadowStyle: 0,
		padding: 15,
		backgroundColor: 'rgb(255,255,255)',
		borderRadius: 4,
		arrowSize: 15,
		borderWidth: 0,
		arrowPosition: 50,
		arrowStyle: 0,
		disableAutoPan: false,
	});

	infowindow.open(map, markers[location.ID]);
};

if (document.getElementById('single-map') || document.querySelector('.location-results')) {
	loadGooglemaps(applicationMaps);
}

document.querySelectorAll<HTMLElement>('[data-clear-filters]').forEach((el) => {
	el.addEventListener('click', (e) => {
		e.preventDefault();
		const input = document.querySelector<HTMLInputElement>(
			'.block-locations-zip-code-search__form input'
		);
		if (input) {
			input.value = '';
			updateLocationSearch();
		}
	});
});
